import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../ApiConfig/ApiConfig';
import moment from 'moment';
import Search from '../../../Assets/Icon search.svg'; // Replace with your actual search icon path
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'; // Import FontAwesome icons
import Cookies from 'js-cookie';
const AllScheme = () => {
  const [schemes, setSchemes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [schemesPerPage] = useState(10); // Number of schemes per page
const token = Cookies.get('admin');
  useEffect(() => {
    const fetchSchemes = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/Scheme/CopySchemes`,
          {
            headers: {  "Content-Type": "application/json" ,
          "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
         },  
          });
        if (response.data.length > 0) {
          setSchemes(response.data); // Set all schemes directly
        }
      } catch (error) {
        console.error('Error fetching schemes:', error);
      }
    };

    fetchSchemes();
  }, []);

  // Filter schemes based on the search term for Scheme ID or Scheme Name
  const filteredSchemes = schemes.filter(scheme =>
    scheme.schemeId.toLowerCase().includes(searchTerm.toLowerCase()) ||
    scheme.schemeName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastScheme = currentPage * schemesPerPage;
  const indexOfFirstScheme = indexOfLastScheme - schemesPerPage;
  const currentSchemes = filteredSchemes.slice(indexOfFirstScheme, indexOfLastScheme);

  const totalPages = Math.ceil(filteredSchemes.length / schemesPerPage);

  // Handle page change
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Generate page numbers for pagination
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="p-6 min-h-screen rounded-lg">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-800">Scheme List</h1>

        {/* Search Input */}
        <div className="flex-shrink-0 w-1/3 relative">
          <input
            type="text"
            placeholder="Search by Scheme ID/Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="p-2 pl-10 pr-3 rounded-lg w-full border border-gray-300 shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300"
          />
          <img
            src={Search} // Replace this with your actual search icon path
            alt="Search Icon"
            className="absolute left-3 top-1/2 transform -translate-y-1/2 w-6 h-6"
          />
        </div>
      </div>

      {/* Table Headers for Desktop */}
      <div className="hidden lg:grid mb-4 grid-cols-3 gap-4 text-[#87909A] font-semibold">
        <p>Scheme ID</p>
        <p>Scheme Name</p>
        <p className="text-right mr-6">Scheme Date</p> {/* Aligning header to the right */}
      </div>

      <div className="container mx-auto">
        {currentSchemes.length > 0 ? (
          currentSchemes.map((scheme, index) => (
            <div
            key={scheme._id}
            className={`bg-transparent lg:${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} lg:shadow-md shadow-none rounded-lg p-4 mb-4 transition-all duration-300 ease-in-out transform group hover:bg-gray-100 hover:scale-[1.02] hover:shadow-lg hover:cursor-pointer`}
          >
          
          
              {/* For Desktop, Display as Grid */}
              <div className="hidden lg:grid lg:grid-cols-3 lg:gap-4 lg:items-center">
                <p className="text-[#292D32] font-semibold group-hover:text-blue-600">{scheme.schemeId}</p>
                <p className="text-[#292D32] font-semibold group-hover:text-blue-600">{scheme.schemeName}</p>
                <p className="text-[#292D32] mr-6 text-right font-semibold group-hover:text-blue-600">
                  {moment(scheme.schemeEndDate.$date).format('YYYY-MM-DD')}
                </p>
              </div>


              {/* For Mobile, Display as Card with Labels on Left and Values on Right */}
              <div className="lg:hidden flex flex-col items-start mt-4 bg-white p-4 rounded-lg shadow-md">
                <div className="flex justify-between w-full">
                  <p className="font-semibold text-[#292D32]">Scheme ID</p>
                  <p className="font-semibold text-[#292D32]">{scheme.schemeId}</p>
                </div>
                <div className="flex justify-between w-full mt-2">
                  <p className="font-semibold text-[#292D32]">Scheme Name</p>
                  <p className="font-semibold text-[#292D32]">{scheme.schemeName}</p>
                </div>
                <div className="flex justify-between w-full mt-2">
                  <p className="font-semibold text-[#292D32]">Scheme Date</p>
                  <p className="font-semibold text-[#292D32]">
                    {moment(scheme.schemeEndDate.$date).format('YYYY-MM-DD')}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="py-3 px-5 text-center text-gray-600">No schemes found.</div>
        )}
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-center mt-6 space-x-3">
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 text-gray-600 rounded-l-lg disabled:opacity-50 text-sm flex items-center font-semibold"
        >
          <FontAwesomeIcon icon={faChevronLeft} className="mr-2" /> Previous
        </button>

        {/* Page Number Buttons */}
        {pageNumbers.map(number => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={`px-3 py-1 mx-1 rounded-lg ${currentPage === number ? 'bg-[#1C50A3] text-white font-semibold' : 'bg-white text-gray-600 font-semibold'} text-sm`}
          >
            {number}
          </button>
        ))}

        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1 text-gray-600 rounded-r-lg disabled:opacity-50 text-sm flex items-center font-semibold"
        >
          Next <FontAwesomeIcon icon={faChevronRight} className="ml-2" />
        </button>
      </div>
    </div>
  );
};

export default AllScheme;
